export default "__VITE_ASSET__D_38F2fY__"